/* istanbul ignore file */ import { DataMap } from '@shared/utils/dataMapping';
import { Constants } from '@shared/utils/constants';
import { getProductByUrlKey } from '@shared/utils/appUtils';
const adminPortal = DataMap.products.AdminPortal;
const powerBIHost = DataMap.products.PowerBI;
const powerBIVisualsHost = DataMap.products.PowerBICustomVisual;
const dynamics365financials = DataMap.products.Dynamics365forBusinessCentral;
const dynamics365 = DataMap.products.Dynamics365;
const dynamicsCRMLegacy = DataMap.products.Dynamics365forSales;
const fullScreenMode = 'fullScreenMode';
export function shouldShowCloseButton(embedHost) {
    return embedHost !== dynamics365financials.UrlKey;
}
export function shouldHideFilterPane(embedHost) {
    return embedHost === powerBIHost.UrlKey || embedHost === dynamics365financials.UrlKey;
}
export function shouldHideIndustriesAndProducts(embedHost) {
    return embedHost !== dynamics365.UrlKey && embedHost !== adminPortal.UrlKey;
}
export function shouldFlatProducts(embedHost) {
    return embedHost === adminPortal.UrlKey;
}
export function hasDynamicData(embedHost) {
    return embedHost === powerBIHost.UrlKey;
}
export function hasPrivateApps(embedHost) {
    return embedHost === powerBIHost.UrlKey || embedHost === dynamics365.UrlKey;
}
export function shouldShowCuratedData(embedHost) {
    return embedHost === dynamics365.UrlKey || embedHost === adminPortal.UrlKey;
}
export function shouldShowPowerAppsNoContent(embedHost) {
    return embedHost === powerBIHost.UrlKey || embedHost === dynamics365.UrlKey;
}
export function shouldShowLegacyStyle(embedHost) {
    return embedHost === dynamics365financials.UrlKey || embedHost === dynamicsCRMLegacy.UrlKey;
}
export function shouldShowVideos(embedHost) {
    return embedHost !== powerBIVisualsHost.UrlKey;
}
export function getPowerAppsTitle() {
    return DataMap.products.PowerApps.Title;
}
export function isFullScreenMode(query) {
    const isFullScreen = query[`${fullScreenMode}`];
    return isFullScreen === 'true';
}
export function shouldShowFilter(embedHost, product) {
    if (embedHost === adminPortal.UrlKey) {
        if (product.FilterID === DataMap.products.OneNote.FilterID && product.FilterGroup === DataMap.products.OneNote.FilterGroup || product.FilterID === DataMap.products.Project.FilterID && product.FilterGroup === DataMap.products.Project.FilterGroup) {
            return false;
        }
    }
    return true;
}
export function isEmbed(embedHost) {
    return embedHost === adminPortal.UrlKey;
}
export function isAppSource(embedHost) {
    return embedHost === null || embedHost === undefined;
}
export function getEmbedHost(queryParams) {
    const embedHost = decodeURIComponent(queryParams.embedHost);
    const productQuery = decodeURIComponent(queryParams.product);
    if (getProductByUrlKey({
        urlKey: embedHost
    })) {
        return embedHost;
    }
    if (getProductByUrlKey({
        urlKey: productQuery
    })) {
        return productQuery;
    }
    return Constants.dynamics365.salesED;
}
function filterPowerBICuratedData(curatedData) {
    const filteredCuratedData = {
        [Constants.Curated.everything]: (curatedData[Constants.Curated.powerPlatform] || []).filter((currentCuratedData)=>currentCuratedData.titleId === Constants.Curated.powerBi)
    };
    return filteredCuratedData;
}
function filterAdminPortalCuratedData(curatedData) {
    return {
        [Constants.Curated.everything]: curatedData[Constants.Curated.office365]
    };
}
function filterDynamicsCuratedData(curatedData) {
    const validKeys = [
        DataMap.products.Dynamics365,
        DataMap.products.Dynamics365forFinancials,
        DataMap.products.Dynamics365forSales,
        DataMap.products.Dynamics365CustomerInsights,
        DataMap.products.Dynamics365forBusinessCentral,
        DataMap.products.Dynamics365forCustomerServices,
        DataMap.products.Dynamics365forSales,
        DataMap.products.Dynamics365forProjectServicesAutomation
    ].filter((dataValues)=>!!(dataValues === null || dataValues === void 0 ? void 0 : dataValues.BackendKey)).map((dataValues)=>dataValues.BackendKey.toLowerCase());
    const filteredCuratedData = {
        [Constants.Curated.everything]: (curatedData[Constants.Curated.dynamics365] || []).filter((currentCuratedData)=>currentCuratedData.titleId && validKeys.indexOf(currentCuratedData.titleId.toLowerCase()) > -1)
    };
    const salesED = DataMap.products.Dynamics365forSales.BackendKey;
    if (salesED && curatedData[`${salesED}`]) {
        filteredCuratedData[`${salesED}`] = curatedData[`${salesED}`];
    }
    return filteredCuratedData;
}
export function filterEmbedCuratedData(embedHost, curatedData) {
    if (embedHost === Constants.dynamics365.dynamics365) {
        return filterDynamicsCuratedData(curatedData);
    } else if (embedHost === Constants.adminPortal) {
        return filterAdminPortalCuratedData(curatedData);
    } else if (embedHost === Constants.PowerBI.powerBi) {
        return filterPowerBICuratedData(curatedData);
    }
    return {};
}
